/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EventManagementGetMemberByEventNumberResponse } from './EventManagementGetMemberByEventNumberResponse';

export type EventManagementGetMemberByEventNumberResponseApiRespoonse = {
    data?: EventManagementGetMemberByEventNumberResponse;
    status?: EventManagementGetMemberByEventNumberResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace EventManagementGetMemberByEventNumberResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

